import styled from "styled-components";

export const DarkBar = styled.h3`
  font-size: ${({ theme }) => theme.fontSize.m} !important;
  color: ${({ theme }) => theme.colors.white} !important;
  background-color: ${({ theme }) => theme.colors.dark} !important;
  font-family: JetBrains Mono;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  max-width: 790px;
  width: 100%;
  padding: 15px;
  margin: 60px 0 10px;
`;
